import UserMenu from "./NavMenu";
import NotificationMenu from "./NotificationMenu";
import { FaMoon, FaSun } from "react-icons/fa6";

const Header = ({ selectedMenu, onToggle, theme = "light", onThemeToggle }) => {
    return (
        <header className="app-header sticky top-0 z-30 flex flex-wrap items-center justify-between gap-2 px-2 py-1.5 shadow-sm">
            <div className="flex min-w-0 items-center gap-2.5">
                <button
                    onClick={onToggle}
                    className="flex h-8 w-8 flex-col items-center justify-center rounded-2xl border border-border bg-white text-text-primary transition hover:border-primary hover:text-primary"
                >
                    <span className="mb-1 block h-0.5 w-6 bg-current"></span>
                    <span className="mb-1 block h-0.5 w-6 bg-current"></span>
                    <span className="block h-0.5 w-6 bg-current"></span>
                </button>

                <div className="min-w-0">
                    <h1 className="truncate text-[15px] font-semibold text-text-primary sm:text-base">
                        {selectedMenu}
                    </h1>
                </div>
            </div>

            <div className="ml-auto flex items-center gap-2">
                <button
                    type="button"
                    onClick={onThemeToggle}
                    aria-label={`Switch to ${theme === "dark" ? "light" : "dark"} mode`}
                    className="theme-toggle flex h-8 items-center gap-1.5 rounded-2xl border border-border bg-white px-2 text-text-primary shadow-sm transition hover:-translate-y-[1px] hover:border-primary hover:text-primary"
                >
                    <span className={`theme-toggle__icon ${theme === "light" ? "is-active" : ""}`}>
                        <FaSun className="text-sm" />
                    </span>
                    <span className={`theme-toggle__icon ${theme === "dark" ? "is-active" : ""}`}>
                        <FaMoon className="text-sm" />
                    </span>
                </button>
                <NotificationMenu />
                <UserMenu />
            </div>
        </header>
    );
};

export default Header;
